import './Main_Section_Banner.css';
import Image_Pwc_Banner from '../Images/pwc_banner.png';
import Image_Pwc_Banner_WomenBot from '../Images/pwc_banner_women&bot.avif';
 
 
 
interface NavigationContent {
  heading: string;
}
 
function Main_Section_Banner({
  heading
 
}:NavigationContent) {
  return (
    <div className='banner-container'>
 
      <div className='banner-main'>
         
        <div className='banner-main-text'>
          <h2>{heading}</h2>
        </div>
 
        {/* <div className='banner-main-image'>
 
        </div> */}
 
      </div>
 
    </div>
     
 
   
   
 
  );
}
 
export default Main_Section_Banner;
 